/**
 * AutomationTab — the Drop Generator of the campaign group open on the
 * SMSWiser country page, beside the Scheduler: the same Board / Day
 * timeline / Live / How it works (and editor) as /admin/drop-generator,
 * locked to that group — no need to pick it again.
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC } from 'react';

import { DropGeneratorCountryView } from '@/pages/admin/drop-generator/country/DropGeneratorCountryView';

interface Props {
  countryKey: string;
  /** A campaign of the open group — the Drop Generator finds its group. */
  campaignWiserId: number;
}

export const AutomationTab: FC<Props> = ({ countryKey, campaignWiserId }) => (
  <div className="flex min-h-0 flex-1 flex-col overflow-y-auto pr-1 pt-2">
    <DropGeneratorCountryView countryKey={countryKey} embed={{ campaignWiserId }} />
  </div>
);

export default AutomationTab;
